import { GetExtranetNewslettersQueryDto } from '@pharmac-extranet/extranet-api'
import { ControlledCheckboxes, useLanguage } from '@pharmac-extranet/shared'
import { PharmacButton } from '@pharmac/ui'
import { useQuery } from '@tanstack/react-query'
import { useEffect, useState } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import { createSearchParams, useSearchParams } from 'react-router-dom'
import { cleanQueryParams } from '../../features/infinite-query/util/cleanQueryParams'
import { api } from '../../services/HttpService'
import {
  ExtranetFiltersColumn,
  ExtranetFiltersFooter,
  ExtranetFiltersRow,
} from '../filters/ExtranetFiltersComponents'
import { mapNewsletterSearchParams } from './mapNewsletterSearchParams'

export const NewsletterFilters = ({ closeFilters }: { closeFilters: () => void }) => {
  const { t, i18n } = useLanguage(['common'])

  const { data, isLoading } = useQuery({
    queryKey: ['__getNewsletterCategories', i18n.language],
    queryFn: async () =>
      await api.newsletterCategories.getCategories({
        lang: i18n.language,
      }),
  })

  const [searchParams, setSearchParams] = useSearchParams()

  const [filters, setFilters] = useState({} as GetExtranetNewslettersQueryDto)

  const formHook = useForm<GetExtranetNewslettersQueryDto>({
    mode: 'onChange',
    defaultValues: {
      categoryIds: [],
    },
  })

  useEffect(() => {
    const params = mapNewsletterSearchParams(searchParams)
    setFilters(params)

    formHook.reset({
      categoryIds: params.categoryIds,
    })
  }, [searchParams])

  const handleFiltersChange = (values: GetExtranetNewslettersQueryDto) => {
    setSearchParams(createSearchParams(cleanQueryParams({ ...filters, ...values })))
    closeFilters()
  }

  const checkboxValues = (data || []).map((category) => ({
    value: category.id,
    name: category.name,
  }))

  if (!data || isLoading) return null

  return (
    <FormProvider {...formHook}>
      <ExtranetFiltersRow>
        <ExtranetFiltersColumn>
          <ControlledCheckboxes
            column
            data={checkboxValues}
            name="categoryIds"
            control={formHook.control}
            label={t('categories', { ns: 'common' })}
          />
        </ExtranetFiltersColumn>
      </ExtranetFiltersRow>
      <ExtranetFiltersFooter>
        <PharmacButton
          disabled={!formHook.formState.isDirty}
          onClick={formHook.handleSubmit(handleFiltersChange)}
        >
          {t('search')}
        </PharmacButton>
      </ExtranetFiltersFooter>
    </FormProvider>
  )
}
